var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 800,
    viewBox: "0 0 1440 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "112.2%",
    height: "112.2%",
    x: "-6.1%",
    y: "-6.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "130%",
    height: "130%",
    x: "-15%",
    y: "-15%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3.948
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "134.5%",
    height: "134.5%",
    x: "-17.2%",
    y: "-17.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: "112.2%",
    height: "112.2%",
    x: "-6.1%",
    y: "-6.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "134.3%",
    height: "134.3%",
    x: "-17.2%",
    y: "-17.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3.948
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: "134.5%",
    height: "134.5%",
    x: "-17.2%",
    y: "-17.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: "112.2%",
    height: "112.2%",
    x: "-6.1%",
    y: "-6.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: "134.5%",
    height: "134.5%",
    x: "-17.2%",
    y: "-17.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 10
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF8A23",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    transform: "translate(552 406)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 346.5,
    cy: 397.5,
    r: 24.5,
    filter: "url(#a)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 314.5,
    r: 39.5,
    filter: "url(#b)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 87,
    r: 87,
    filter: "url(#c)",
    opacity: 0.138
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "matrix(1 0 0 -1 1073 711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 326.5,
    cy: 397.5,
    r: 24.5,
    filter: "url(#d)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271,
    cy: 642,
    r: 60,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 309.5,
    r: 34.5,
    filter: "url(#e)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 87,
    r: 87,
    filter: "url(#f)",
    opacity: 0.138
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "translate(-82 -54)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 346.5,
    cy: 479.5,
    r: 24.5,
    filter: "url(#g)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 724,
    r: 60,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888,
    cy: 60,
    r: 60,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303,
    cy: 169,
    r: 87,
    filter: "url(#h)",
    opacity: 0.138
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBackground);
export default __webpack_public_path__ + "static/media/success-background.24b866950c2f48275c7be7eda4294906.svg";
export { ForwardRef as ReactComponent };